var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingleFamily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9167 33.0665V18.6562C32.9167 18.2157 32.6991 17.8036 32.3354 17.5552L23.0021 11.1802C22.5486 10.8704 21.9515 10.8704 21.498 11.1802L12.1647 17.5552C11.8009 17.8036 11.5834 18.2157 11.5834 18.6562V33.0665C11.5834 33.2138 11.7028 33.3332 11.85 33.3332H18.7834C18.9307 33.3332 19.05 33.2138 19.05 33.0665V27.5566C19.05 27.1884 19.3485 26.89 19.7167 26.89H24.7834C25.1516 26.89 25.45 27.1884 25.45 27.5566V33.0665C25.45 33.2138 25.5694 33.3332 25.7167 33.3332H32.65C32.7973 33.3332 32.9167 33.2138 32.9167 33.0665Z",
    fill: "#ACB1BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleFamily);
export default __webpack_public_path__ + "static/media/single-family.4bde742d834b9ed3cba3facacf19e18e.svg";
export { ForwardRef as ReactComponent };